import axios from "axios";

export default axios.create({
  baseURL: "https://api.safelyread.com",
  responseType: "json",
  timeout: 30000,
});
